<template>
  <input
    class="w-full border text-center backdrop-blur-sm bg-white/30 p-2 rounded-lg shadow-lg text-black disabled:bg-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
    :placeholder="placeholder"
    :disabled="disabled"
    :type="type"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    @keydown="$emit('keydown')"
    :class="{ 'border border-red-500': error }"
  />
</template>

<script>
export default {
  name: "VInput",
  props: ["placeholder", "type", "modelValue", "disabled", "error"],
  emits: ["update:modelValue", "keydown"],
};
</script>

<style scoped>
input::placeholder,
textarea::placeholder {
  color: #fff;
}
</style>
